import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import AudioSection from './components/AudioSection';
import ThreeStepSystem from './components/ThreeStepSystem';
import StepForm from './components/StepForm';
import VideoSection from './components/VideoSection';
import DemoForm from './components/DemoForm';
import SystemConfirmation from './components/SystemConfirmation';
import WhatsAppContact from './components/WhatsAppContact';
import ProgressBar from './components/ProgressBar';

export default function Home() {
  const [currentStep, setCurrentStep] = useState(1);
  const [audioChecked, setAudioChecked] = useState(false);
  const [formData, setFormData] = useState<any>({});

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentStep]);

  const canProceedToStep2 = audioChecked;

  const handleStep1Next = (data: any) => {
    setFormData((prev: any) => ({ ...prev, ...data }));
    setCurrentStep(2);
  };

  const handleStep3Next = (data: any) => {
    setFormData((prev: any) => ({ ...prev, ...data }));
    setCurrentStep(4);
  };

  const handleStep2Next = () => {
    setCurrentStep(3);
  };

  const handleStep4Next = () => {
    setCurrentStep(5);
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <ProgressBar currentStep={currentStep} />

      {currentStep === 1 && (
        <div className="relative">
          <Hero />
          <ThreeStepSystem />
          <AudioSection
            audioChecked={audioChecked}
            setAudioChecked={setAudioChecked}
          />
          <StepForm
            onNext={handleStep1Next}
            canProceed={canProceedToStep2}
          />
        </div>
      )}

      {currentStep === 2 && (
        <VideoSection onNext={handleStep2Next} />
      )}

      {currentStep === 3 && (
        <DemoForm onNext={handleStep3Next} />
      )}

      {currentStep === 4 && (
        <SystemConfirmation onNext={handleStep4Next} />
      )}

      {currentStep === 5 && (
        <WhatsAppContact />
      )}
    </div>
  );
}